import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { CarProductIntroFormValues, VehicleInputType } from "./interfaces";

import { updateStep } from "Store/steps/stepsSlice";
import { useFormikContext } from "formik";
import isEmpty from "lodash.isempty";
import { CAR_FIND_STEP } from "../../carSteps";
import { useViewModel } from "./OwnedVehicles/hooks";

export function useHandleCarInfoUpdates(): void {
  const formProps = useFormikContext<CarProductIntroFormValues>();
  const dispatch = useDispatch();
  const { licensePlateNumber, brand, model, year } = formProps.values;

  useEffect(() => {
    let subTitle;

    if (!isEmpty(licensePlateNumber)) {
      if (!isEmpty(brand) && !isEmpty(model)) {
        subTitle = `${brand} ${model} ${licensePlateNumber}`;
      } else {
        subTitle = licensePlateNumber;
      }
    } else if (!isEmpty(brand) && !isEmpty(model) && !isEmpty(year)) {
      subTitle = `${brand} ${model} ${year}`;
    }

    dispatch(
      updateStep({
        stepId: CAR_FIND_STEP.id,
        stepUpdate: {
          subTitle,
        },
      }),
    );
  }, [licensePlateNumber, brand, model, year]);
}

export function useHandleDefaultsForCustomerWithoutOwnedVehicles(): void {
  const {
    data: { vehicles },
  } = useViewModel();
  const formProps = useFormikContext<CarProductIntroFormValues>();

  const doesCustomerHaveOwnedVehicles = vehicles.length > 0;

  useEffect(() => {
    if (
      !doesCustomerHaveOwnedVehicles &&
      formProps.values.vehicleInputType === VehicleInputType.OWNED
    ) {
      formProps.setFieldValue(
        "vehicleInputType",
        VehicleInputType.LICENSE_PLATE,
      );
    }
  }, [doesCustomerHaveOwnedVehicles]);
}
